import api from "./apiWithAccessToken";

export const listFaqs = async (sourceDbConfigId, { signal } = {}) => {
  const { data } = await api.get("/faqs", {
    params: { source_db_config_id: sourceDbConfigId },
    signal,
  });
  return data.items;
};
